module.exports = __webpack_public_path__ + "img/icon-yb.c2725993.png";